import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap CSS is imported
import EyeIcon from '../../../imgs/eye-icon.svg';
import EditIcon from '../../../imgs/edit-icon.svg';

const Step3Form = () => {
    const handleSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <>
            <form onSubmit={handleSubmit} className="container form-2">
                <div className='form-heading-wrapper'>
                    <h3>Vérifier les informations du document</h3>
                </div>
                <div className='fiels-main-wrapper pb-5'>
                    <div className='action-btn'>
                        <Link to="/" className="btn btn-primary">
                            Voir les données sur la blockchain
                        </Link>
                    </div>

                    <div className='custom-table'>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Nom du document</th>
                                    <th>Date de création</th>
                                    <th>Auteur</th>
                                    <th>Description</th>
                                    <th>Hash Document</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Blockchain</td>
                                    <td>XX/XX/XXXX</td>
                                    <td>Agent 1</td>
                                    <td>Lorem Ipsum</td>
                                    <td>A23hdç</td>
                                    <td>
                                        <Button variant="link">
                                            <img src={EyeIcon} alt="View" />
                                        </Button>
                                        <Button variant="link">
                                            <img src={EditIcon} alt="Edit" />
                                        </Button>
                                    </td>
                                </tr>
                                <tr>
                                    <td>Blockchain</td>
                                    <td>XX/XX/XXXX</td>
                                    <td>Agent 2</td>
                                    <td>Lorem Ipsum</td>
                                    <td>A23hdç</td>
                                    <td>
                                        <Button variant="link" >
                                            <img src={EyeIcon} alt="View" />
                                        </Button>
                                        <Button variant="link">
                                            <img src={EditIcon} alt="Edit" />
                                        </Button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className='btn-wrapper'>
                        <button type="submit" className="btn btn-primary">
                            Soumettre
                        </button>
                    </div>

                    <div className='custom-info-wrapper'>
                        <p>Veuillez enregistrer cette URL pour revenir à cette session ultérieurement:  https://frfrfrfrrfrffrf</p>
                    </div>
                </div>
            </form>
        </>
    );
};

export default Step3Form;
